// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('System.UserIdAndName')
class System__UserIdAndName {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "none" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["userId", "name", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["userId", "name", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["userId", "name", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "userId": "string", "name": "string", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["name"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θuserId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θname? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'System.UserIdAndName' {
        return 'System.UserIdAndName'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'System.UserIdAndName' {
        return 'System.UserIdAndName'
    }

    static get __baseType(): 'System.UserIdAndName' {
        return 'System.UserIdAndName'
    }

    set __baseType(_) {
    }

    get __baseType(): 'System.UserIdAndName' {
        return 'System.UserIdAndName'
    }

    get [BoInfoSymbol]() {
        return System__UserIdAndName[BoInfoSymbol]
    }

    get userId(): string {
        return this.θuserId?.()
    }

    set userId(userId) {
        this.θuserId.set(LowgileDataUtil.coerceDataType(userId, 'string', false, true))
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(LowgileDataUtil.coerceDataType(name, 'string', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<System__UserIdAndName>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new System__UserIdAndName()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<System__UserIdAndName>, restrictToClass?: Class<Partial<System__UserIdAndName>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            userId: z.string(),
            name: z.string(),
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return System__UserIdAndName.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []

        names.push('userId', 'name', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is System__UserIdAndName {
        return equal(this, other)
    }
}

namespace System__UserIdAndName { }

export import UserIdAndName = System__UserIdAndName
setTimeout(() => {
    jsonProperty(() => String)(System__UserIdAndName.prototype, 'userId')
    jsonProperty(() => String)(System__UserIdAndName.prototype, 'name')
    jsonProperty(() => Date)(System__UserIdAndName.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(System__UserIdAndName.prototype, 'createdBy')
    jsonProperty(() => Date)(System__UserIdAndName.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(System__UserIdAndName.prototype, 'updatedBy')
    jsonProperty(() => Date)(System__UserIdAndName.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(System__UserIdAndName.prototype, 'deletedBy')
    jsonProperty(() => Number)(System__UserIdAndName.prototype, 'versionNumber')
})
